<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <screen-loading :show="show_loading" />
    <!-- Brand Logo -->
    <a
      href="#"
      class="brand-link"
      @click="navigate({ name: 'Login'})"
    >
      <!--
      <img
        src="@/assets/AdminLTELogo.png"
        alt="Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: .8"
      >
      -->
      <b-icon
        icon="layout-wtf"
        font-scale="1.4"
        style="margin: 0px .5rem 0px .9rem"
      />
      <span class="brand-text font-weight-bold">
        招標平臺
      </span>
    </a>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <!-- Add icons to the links using the .nav-icon class
          with font-awesome or any other icon font library-->
          <li class="nav-item has-treeview menu-open">
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  :to="bidding"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>{{ biddingDisplay }}</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  :to="user"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>{{ userDisplay }}</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="userRole == 'A'"
            class="treeview nav-item settings"
          >
            <a
              class="nav-link link-pointer"
              @click="expandTree('settings')"
            >
              <i class="nav-icon fa fa-sliders" />
              <p>設定
                <i class="right fa fa-angle-left" />
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  :to="{name: 'AdminBiddingGuide'}"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-thin nav-icon" />
                  <p>招標指南</p>
                </router-link>
              </li>
            </ul>
          </li>
          <!-- /.sidebar-menu -->
        </ul>
      </nav>
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import ScreenLoading from '../functions/Common/plugins/ScreenLoading'
export default {
  name: 'Sidebar',
  components: {
    ScreenLoading
  },
  data: function () {
    return {
      show_loading: false
    }
  },
  computed: {
    userRole () {
      return this.$store.state.Auth.role
    },
    bidding () {
      if (this.$store.state.Auth.role === 'A') return {name: 'AdminBidding'}
      else if (this.$store.state.Auth.role === 'SC') return {name: 'SchoolBidding'}
      else if (this.$store.state.Auth.role === 'TC') return {name: 'TourCompanyBidding'}
      else return 'Login'
    },
    user () {
      if (this.$store.state.Auth.role === 'A') return {name: 'AdminUser'}
      else if (this.$store.state.Auth.role === 'SC') return {name: 'SchoolUser'}
      else if (this.$store.state.Auth.role === 'TC') return {name: 'TourCompanyUser'}
      else return 'Login'
    },
    biddingDisplay () {
      if (this.$store.state.Auth.role === 'A' || this.$store.state.Auth.role === 'SC') return '招標管理'
      else return '查看招標'
    },
    userDisplay () {
      if (this.$store.state.Auth.role === 'A') return '用戶管理'
      else return '賬號管理'
    }
  },
  methods: {
    navigate (to) {
      this.show_loading = true
      this.$router.push(to, () => { this.show_loading = false }, () => { this.show_loading = false })
    },
    expandTree (cssClass) {
      if ($('.' + cssClass).hasClass('menu-open')) {
        $('.' + cssClass).removeClass('menu-open')
      } else {
        $('.' + cssClass).addClass('menu-open')
      }
    }
  }
}
</script>

<style scoped>
  .child-indent {
    padding-left: 1rem;
  }
</style>
